import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentSearchResult } from '../../document/models/documentSearchResult';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyDocCollabsService {

  constructor(private httpClient: HttpClient) { }

  getMyDocCollabs(includeAll: boolean): Observable<DocumentSearchResult[]> {
    return this.httpClient.get<DocumentSearchResult[]>(ApiConstants.DocumentMyDocCollabs_Api+"/"+includeAll);
  }
}
